import { SelectionFeature } from "src/js/stores/map/store";
import { SubSectionHeader } from "react-migration/components/SubSectionHeader/SubSectionHeader";
import { useTransactionsAtSelection } from "./useTransactionsAtSelection";
import { TransactionsAccordion } from "./TransactionsAccordion";

interface OtherComparablesSectionProps {
  selection: SelectionFeature;
  onSelection?: (selection: SelectionFeature | undefined) => void;
}

export function OtherComparablesSection({ selection, onSelection }: OtherComparablesSectionProps) {
  const { includedResults, loading, selectRecord } = useTransactionsAtSelection(selection, onSelection);

  if (loading || !includedResults?.length) return null;

  return (
    <section className="flex flex-col gap-y-2">
      <div className="px-3">
        <SubSectionHeader count={loading ? undefined : includedResults.length}>
          Other property transactions
        </SubSectionHeader>
      </div>
      <div className="px-1 pb-1">
        <TransactionsAccordion includedResults={includedResults} loading={loading} setSelectedRecord={selectRecord} />
      </div>
    </section>
  );
}
